<template>
  <v-container   style="max-width:1280px;">
    <h1 class="roboto font-weight-thin text-uppercase  border-bottom-text mr-3">
      Informativa sui Cookie


    </h1>
    <v-col class="border-shadow pa-0"></v-col>
  <p style="text-align: center;">Informativa sui Cookie</p>
  <p>Questo Portale web (il <strong>Portale</strong>) utilizza i <strong>cookie</strong> che sono piccoli file di testo salvati sul terminale durante la navigazione e che rimangono installati sul dispositivo e interagiscono con il Portale medesimo o con un diverso sito web (cookie di terze parti).</p>
  <p>A seconda delle caratteristiche, questi piccoli file di testo possono essere memorizzati per un periodo specifico sul dispositivo (per es. mesi o anni), oppure venire rimossi in automatico alla fine di ogni sessione.</p>
  <p>Su questo Portale viene fatto uso dei seguenti cookie:</p>
  <ul>
    <li><strong>Tecnici (necessari)</strong> e di terze parti</li>
  </ul>
  <p>Viene fatto uso di cookie di sessione e persistenti limitatamente a quanto necessario per la navigazione sicura ed efficiente del sito. Utili per esempio per fare accedere l&rsquo;utente senza inserire le credenziali. I cookie di sessione vengono rimossi alla chiusura del browser, quelli persistenti vengono mantenuti fino alla scadenza o possono essere cancellati dall&rsquo;utente.</p>
  <p>Essendo cookie necessari al funzionamento del sito, disabilitarli potrebbe pregiudicare le funzioni del sito.</p>
  <p>Non si fa uso di cookie di terze parti</p>
  <ul>
    <li><strong>Analitici</strong></li>
  </ul>
  <p>Viene fatto uso di cookie analitici (o di misurazione) allo scopo di raccogliere dati statistici aggregati di accesso e di utilizzo del sito. Per questi cookie sono state adottate misure, quali per esempio l&rsquo;anonimizzazione, che ne riducono il potere identificativo, rendendoli equiparabili a cookie tecnici.</p>
  <ul>
    <li><strong>Marketing e altro tracciamento</strong> (<em>profilazione</em>)</li>
  </ul>
  <p>Sul nostro Portale non facciamo uso di cookie di marketing e altro tracciamento (<em>profilazione</em>)</p>
  <p>A seguire una lista delle pagine di riferimento per la gestione dei cookie nei principali browser (si ricorda che le istruzioni potrebbero cambiare in base al dispositivo o sistema operativo utilizzato):</p>
  <ul>
    <li>Chrome: https://support.google.com/chrome/answer/95647</li>
    <li>Firefox: https://support.mozilla.org/it/kb/Gestione%20dei%20cookie</li>
    <li>Internet Explorer: https://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies</li>
    <li>Opera: https://help.opera.com/en/latest/web-preferences/#cookies</li>
    <li>Safari: https://support.apple.com/HT201265</li>
  </ul>
  <p>Le informazioni fornite possono essere soggette a revisione. Gli utenti sono invitati a visitare periodicamente la presente pagina, in modo da essere costantemente aggiornati.</p>
  <p>Ulteriori dettagli circa le finalit&agrave; e le modalit&agrave; di trattamento di eventuali dati personali acquisiti tramite questo Portale sono reperibili nell'Informativa sulla privacy rinvenibile al seguente indirizzo web <a href="https://spesaromacircomassimo.campagnamica.it/privacy-policy">https://spesaromacircomassimo.campagnamica.it/privacy-policy</a>.</p>
</v-container></template>

<script>
export default {
  name: "TermsCookies"
}
</script>

<style scoped>

</style>